import { all } from 'redux-saga/effects';
import watchPdfFlyerRequest from './watchPdfFlyerRequest';
import watchPdfPrintTypesRequest from './watchPdfPrintTypesRequest';
import watchPdfRequest from './watchPdfRequest';
import watchPrintFilterData from './watchPrintFilterData';
import watchPrintGetRequest from './watchPrintGetRequest';
import watchPrintUpdateRequest from './watchPrintUpdateRequest'
import watchPdfWeekProgramFlyerRequest from './watchPdfWeekProgramFlyerRequest';
import watchChooseCinema from './watchChooseCinema';
import watchPdfNewspaperRequest from './watchPdfNewspaperRequest';


function* printSaga() {
    yield all([
        watchPrintGetRequest(),
        watchPrintUpdateRequest(),
        watchPdfRequest(),
        watchPdfFlyerRequest(),
        watchPdfPrintTypesRequest(),
        watchPrintFilterData(),
        watchPdfWeekProgramFlyerRequest(),
        watchChooseCinema(),
        watchPdfNewspaperRequest()
    ])
}

export default printSaga;